import { useCallback } from "react";

import {
  copyGifLink,
  getGifFixedEmbedCode,
  getGifResponsiveEmbedCode,
  sendGifToTwitter,
  sendGifToReddit,
} from "utils/share";

import { IGif } from "services/types";
import { ShareMenu } from "./ShareMenu";
import { metrics } from "utils/metrics";

interface IShareGifMenuProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  fullscreen?: boolean;
}

export const ShareGifMenu = (props: IShareGifMenuProps) => {
  const { gif, anchorEl, onClose, fullscreen = false } = props;

  const handleClick = useCallback(async (label: string) => {
    if (label === "Copy Link") {
      await copyGifLink(gif);
      await metrics.sendShareCopy();
    } else if (label === "Discord") {
      await copyGifLink(gif);
      await metrics.sendShareDiscord();
    } else if (label === "Reddit") {
      sendGifToReddit(gif);
      await metrics.sendShareReddit();
    } else if (label === "Twitter") {
      sendGifToTwitter(gif.id);
      await metrics.sendShareTwitter();
    }

    onClose();
  }, [gif, onClose]);

  return (
    <ShareMenu
      anchorEl={anchorEl}
      onClick={handleClick}
      onClose={onClose}
      fixedEmbedCode={getGifFixedEmbedCode(gif)}
      responsiveEmbedCode={getGifResponsiveEmbedCode(gif)}
      fullscreen={fullscreen}
    />
  );
};
